/**
 * ファイル情報
 */
 export default class FileData {
    /** ファイル名 */
    filename = ""
    /** データ */
    content = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<FileData>) {
        Object.assign(this, init)
    }

}
